import React from "react"

import { Box, styled } from "@mui/material"

export const ContentBox = styled(Box)<{ component?: React.ElementType }>(({ theme }) => ({
  backgroundColor: theme.palette.mockup.primary99,
  flex: "1 1 auto",
  padding: "28px 16px",
  [theme.breakpoints.up("tablet")]: {
    padding: "40px 24px",
  },
}))

export const SkipLink = styled("a")(({ theme }) => ({
  position: "absolute",
  top: "-40px",
  left: 0,
  zIndex: theme.zIndex.tooltip + 1,
  padding: "8px 16px",
  backgroundColor: theme.palette.mockup.primary99,
  color: theme.palette.primary.main,
  "&:focus": {
    top: 0,
  },
}))
